import { RestResource } from "./common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class EventCategory extends RestResource {
  activeEventsCount = 0
  category = ""
  displayName = ""
  groupCode = ""
  productCodes: string[] = []
  tradeableEventContractsCount = 0
  underlyingSymbol = ""
}

export const EVENT_CATEGORY_DESER: SchemaDeSer<EventCategory> =
  new SchemaDeSerBuilder(EventCategory)
    .ofInt("activeEventsCount", { jsonField: "active-events-count" })
    .ofString("category")
    .ofString("displayName", "display-name")
    .ofString("groupCode", "group-code")
    .ofPrimitiveArray("productCodes", "product-codes")
    .ofInt("tradeableEventContractsCount", {
      jsonField: "tradeable-event-contracts-count",
    })
    .ofString("underlyingSymbol", "underlying-symbol")
    .toDeSer()
